// CozyCub Theme JS
// Aligned with Shopify Ajax API for cart interactions and local UI state management

document.addEventListener('DOMContentLoaded', function() {
  // Mobile Navigation Toggle
  initMobileNav();

  // Homepage Tab Selector
  initTabs();

  // Product Accordion (PDP)
  initAccordions();

  // Product Gallery (PDP)
  initGallery();

  // Quantity Selectors
  initQuantitySelectors();

  // Initialize AJAX Cart triggers
  initAjaxCart();

  // Advanced CozyCub Sections Init
  initQuiz();
  initReviewsCarousel();
  initFaqAccordion();
  initNewsletterCoupon();

  // Search Modal & Mega Menu Init
  initSearchModal();
  initMegaMenu();

  // Hero Slider Swiper Init
  initHeroSlider();

  // Featured Products Slider Swiper Init
  initFeaturedProductsSlider();

  // In Action Reels Slider Swiper Init
  initInActionSlider();
});

// Mobile Navigation
function initMobileNav() {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.getElementById('MobileNav');
  const overlay = document.getElementById('MobileNavOverlay');
  const closeBtns = document.querySelectorAll('.mobile-nav__close');
  const panelTriggers = document.querySelectorAll('.panel-trigger');
  const backBtns = document.querySelectorAll('.panel-back-btn');

  if (!menuBtn || !mobileNav || !overlay) return;

  function openMenu() {
    mobileNav.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileNav.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    // Reset all sub-panels back to off-screen right
    document.querySelectorAll('.mobile-nav__panel').forEach(panel => {
      panel.classList.remove('panel-active');
    });
  }

  menuBtn.addEventListener('click', openMenu);
  overlay.addEventListener('click', closeMenu);
  
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeMenu);
  });

  // Category panel slide triggers
  panelTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-target');
      const targetPanel = document.getElementById(targetId);
      if (targetPanel) {
        targetPanel.classList.add('panel-active');
      }
    });
  });

  // Panel slide back buttons
  backBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const panel = this.closest('.mobile-nav__panel');
      if (panel) {
        panel.classList.remove('panel-active');
      }
    });
  });
}

// Homepage Collection Tabs
function initTabs() {
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');

  if (tabBtns.length === 0) return;

  tabBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const targetId = this.dataset.tab;

      // Deactivate all
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // Activate clicked
      this.classList.add('active');
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
}

// PDP Accordions
function initAccordions() {
  const headers = document.querySelectorAll('.pdp-accordion__header');

  headers.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.parentElement;
      item.classList.toggle('open');
    });
  });
}

// PDP Gallery Thumbnail Selection
function initGallery() {
  const thumbs = document.querySelectorAll('.pdp-gallery__thumb');
  const mainImg = document.querySelector('.pdp-gallery__featured img');

  if (thumbs.length === 0 || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const newSrc = this.querySelector('img').dataset.zoom || this.querySelector('img').src;
      mainImg.src = newSrc;
    });
  });
}

// Quantity Selector Buttons
function initQuantitySelectors() {
  document.body.addEventListener('click', function(e) {
    if (e.target.matches('.qty-btn')) {
      const input = e.target.parentElement.querySelector('input');
      if (!input) return;
      
      let val = parseInt(input.value) || 1;
      const step = e.target.classList.contains('qty-btn--plus') ? 1 : -1;
      
      const cartItem = e.target.closest('[data-cart-item-key]');
      const isCartPageItem = e.target.closest('.cart-page__item-tr');

      if (cartItem || isCartPageItem) {
        val = Math.max(0, val + step);
      } else {
        val = Math.max(1, val + step);
      }

      input.value = val;

      // If inside cart, trigger update
      if (cartItem) {
        const key = cartItem.dataset.cartItemKey;
        updateCartQuantity(key, val);
      } else if (isCartPageItem) {
        if (val === 0) {
          const removeLink = e.target.closest('.cart-page__item-tr').querySelector('.cart-page__item-remove');
          if (removeLink) window.location.href = removeLink.href;
        } else {
          e.target.closest('form').submit();
        }
      }
    }
  });
}

/* --- Cart Drawer Functions (AJAX API) --- */
function openCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
}

// Expose open/close globally
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;

function initAjaxCart() {
  // Capture AJAX Form submits (like Product Add-to-cart)
  document.body.addEventListener('submit', function(e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);

      // Add to Cart via Shopify API
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Open the cart drawer
        openCartDrawer();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    }
  });

  // Open cart drawer from header cart icon click
  const cartIcon = document.querySelector('.header__icon--cart');
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }
}

// Fetch current cart state and re-render Drawer HTML
function refreshCartDrawer() {
  const contentDiv = document.getElementById('CartDrawerContent');
  const countBadge = document.querySelector('.header__icon-count');
  
  if (!contentDiv) return;

  fetch(window.routes.cart_url + '.js')
  .then(response => response.json())
  .then(cart => {
    // Update Header Counter
    if (countBadge) {
      countBadge.textContent = cart.item_count;
      countBadge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    if (cart.item_count === 0) {
      contentDiv.innerHTML = `
        <div class="cart-drawer__empty">
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          <p>Your cart is empty.</p>
          <button class="btn btn--primary" style="margin-top: 20px;" onclick="closeCartDrawer()">Continue Shopping</button>
        </div>
      `;
      return;
    }

    let itemsHtml = '';
    cart.items.forEach(item => {
      const variantTitle = item.variant_title ? item.variant_title : '';
      const finalPrice = formatMoney(item.final_price);
      
      itemsHtml += `
        <div class="cart-item" data-cart-item-key="${item.key}">
          <div class="cart-item__image">
            <img src="${item.image || 'https://via.placeholder.com/100'}" alt="${item.title}">
          </div>
          <div class="cart-item__details">
            <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
            <div class="cart-item__variant">${variantTitle}</div>
            <div class="cart-item__price-quantity">
              <span class="cart-item__price">${finalPrice}</span>
              <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 6px;">
                <div class="cart-item__quantity-selector">
                  <button type="button" class="qty-btn qty-btn--minus">-</button>
                  <input type="text" value="${item.quantity}" readonly>
                  <button type="button" class="qty-btn qty-btn--plus">+</button>
                </div>
                <button type="button" class="cart-item__remove-btn" onclick="updateCartQuantity('${item.key}', 0)">Remove</button>
              </div>
            </div>
          </div>
        </div>
      `;
    });

    contentDiv.innerHTML = `
      <div class="cart-drawer__items-list">
        ${itemsHtml}
      </div>
      <div class="cart-drawer__upsell-container"></div>
      <div class="cart-drawer__footer">
        <div class="cart-drawer__subtotal">
          <span>Subtotal</span>
          <span>${formatMoney(cart.total_price)}</span>
        </div>
        <p class="cart-drawer__shipping-note">Taxes and shipping calculated at checkout</p>
        <a href="/checkout" class="btn btn--primary btn--full">Proceed to Checkout</a>
      </div>
    `;

    // Load dynamic upsell suggestions based on cart items
    loadCartSuggestions(cart.items);
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
    contentDiv.innerHTML = '<div class="cart-drawer__loading">Error loading cart. Please try again.</div>';
  });
}

// Dynamic cart drawer addon recommendations
let cachedProductsList = null;

window.addAddonToCart = function(variantId) {
  if (!variantId) return;
  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  })
  .then(response => {
    if (!response.ok) {
      console.warn("Addon variant addition failed");
    }
    return response;
  })
  .then(() => {
    refreshCartDrawer();
  })
  .catch(error => {
    console.error('Error adding addon to cart:', error);
  });
};

function loadCartSuggestions(cartItems) {
  const container = document.querySelector('.cart-drawer__upsell-container');
  if (!container) return;

  let hasGamingChair = false;
  let hasMattress = false;
  let hasOfficeChair = false;

  cartItems.forEach(item => {
    const title = (item.product_title || item.title || '').toLowerCase();
    if (title.includes('gaming chair') || title.includes('apex pro')) {
      hasGamingChair = true;
    } else if (title.includes('mattress')) {
      hasMattress = true;
    } else if (title.includes('office chair') || title.includes('ergomax')) {
      hasOfficeChair = true;
    }
  });

  let fetchPromise = cachedProductsList 
    ? Promise.resolve(cachedProductsList) 
    : fetch('/products.json')
        .then(r => r.json())
        .then(data => {
          cachedProductsList = data.products || [];
          return cachedProductsList;
        })
        .catch(e => {
          console.warn("Could not fetch products.json for addons", e);
          return [];
        });

  fetchPromise.then(products => {
    let suggestions = [];

    // Determine which recommended addons to suggest based on cart items
    if (hasMattress && hasGamingChair) {
      suggestions = [
        {
          key: 'pillow',
          terms: ['pillow'],
          exclude: ['chair', 'office'],
          fallback: {
            id: 454345345346,
            title: 'Premium Memory Foam Pillow',
            price: '999.00',
            image: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'cushion',
          terms: ['cushion', 'support', 'lumbar'],
          exclude: ['mattress', 'bed'],
          fallback: {
            id: 454345345348,
            title: 'Orthopedic Lumbar Support Cushion',
            price: '1499.00',
            image: 'https://images.unsplash.com/photo-1592078615290-033ee584e267?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'eyemask',
          terms: ['eye mask', 'mask'],
          exclude: [],
          fallback: {
            id: 454345345352,
            title: 'Cozy Sleep & Game Eye Mask',
            price: '499.00',
            image: 'https://images.unsplash.com/photo-1511317558614-268393791416?q=80&w=200&auto=format&fit=crop'
          }
        }
      ];
    } else if (hasGamingChair) {
      suggestions = [
        {
          key: 'cushion',
          terms: ['cushion', 'support', 'lumbar'],
          exclude: ['mattress', 'bed'],
          fallback: {
            id: 454345345348,
            title: 'Orthopedic Lumbar Support Cushion',
            price: '1499.00',
            image: 'https://images.unsplash.com/photo-1592078615290-033ee584e267?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'neckpillow',
          terms: ['neck support', 'neck pillow', 'neck roll'],
          exclude: [],
          fallback: {
            id: 454345345349,
            title: 'Ergonomic Neck Support Pillow',
            price: '799.00',
            image: 'https://images.unsplash.com/photo-1520038410233-7141be7e6f97?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'mousepad',
          terms: ['mouse pad', 'desk mat', 'mousepad'],
          exclude: [],
          fallback: {
            id: 454345345350,
            title: 'Apex Pro Gaming Mouse Pad',
            price: '999.00',
            image: 'https://images.unsplash.com/photo-1615663245857-ac93bb7c39e7?q=80&w=200&auto=format&fit=crop'
          }
        }
      ];
    } else if (hasMattress) {
      suggestions = [
        {
          key: 'pillow',
          terms: ['pillow'],
          exclude: ['chair', 'office'],
          fallback: {
            id: 454345345346,
            title: 'Premium Memory Foam Pillow',
            price: '999.00',
            image: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'protector',
          terms: ['protector', 'cover'],
          exclude: ['chair', 'sofa', 'office'],
          fallback: {
            id: 454345345347,
            title: 'Waterproof Mattress Protector',
            price: '1299.00',
            image: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'comforter',
          terms: ['comforter', 'bedsheet', 'duvet'],
          exclude: [],
          fallback: {
            id: 454345345351,
            title: 'All-Season Cozy Comforter',
            price: '2499.00',
            image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=200&auto=format&fit=crop'
          }
        }
      ];
    } else if (hasOfficeChair) {
      suggestions = [
        {
          key: 'cushion',
          terms: ['cushion', 'support', 'lumbar'],
          exclude: ['mattress', 'bed'],
          fallback: {
            id: 454345345348,
            title: 'Orthopedic Lumbar Support Cushion',
            price: '1499.00',
            image: 'https://images.unsplash.com/photo-1592078615290-033ee584e267?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'footrest',
          terms: ['footrest', 'foot rest'],
          exclude: [],
          fallback: {
            id: 454345345353,
            title: 'Ergonomic Under-Desk Footrest',
            price: '1199.00',
            image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'giftcard',
          terms: ['gift card', 'giftcard'],
          exclude: [],
          fallback: {
            id: 454345345345,
            title: 'CozyCub Gift Card',
            price: '10.00',
            image: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?q=80&w=200&auto=format&fit=crop'
          }
        }
      ];
    } else {
      suggestions = [
        {
          key: 'pillow',
          terms: ['pillow'],
          exclude: ['chair', 'office'],
          fallback: {
            id: 454345345346,
            title: 'Premium Memory Foam Pillow',
            price: '999.00',
            image: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'cushion',
          terms: ['cushion', 'support', 'lumbar'],
          exclude: ['mattress', 'bed'],
          fallback: {
            id: 454345345348,
            title: 'Orthopedic Lumbar Support Cushion',
            price: '1499.00',
            image: 'https://images.unsplash.com/photo-1592078615290-033ee584e267?q=80&w=200&auto=format&fit=crop'
          }
        },
        {
          key: 'protector',
          terms: ['protector', 'cover'],
          exclude: ['chair', 'sofa', 'office'],
          fallback: {
            id: 454345345347,
            title: 'Waterproof Mattress Protector',
            price: '1299.00',
            image: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?q=80&w=200&auto=format&fit=crop'
          }
        }
      ];
    }

    // Helper to find a product matching terms and excluding others
    function findProductByTermsLocal(products, terms, excludeTerms = []) {
      return products.find(p => {
        const title = p.title.toLowerCase();
        const handle = p.handle.toLowerCase();
        const matchesTerm = terms.some(term => title.includes(term) || handle.includes(term));
        if (!matchesTerm) return false;
        const matchesExclude = excludeTerms.some(term => title.includes(term) || handle.includes(term));
        return !matchesExclude;
      });
    }

    // Map suggestions only from genuinely found store products
    let mappedSuggestions = [];
    suggestions.forEach(s => {
      const found = findProductByTermsLocal(products, s.terms, s.exclude);
      if (found && found.variants && found.variants.length > 0) {
        const availVariant = found.variants.find(v => v.available) || found.variants[0];
        mappedSuggestions.push({
          id: availVariant.id,
          title: found.title,
          price: availVariant.price,
          image: found.images[0]?.src || s.fallback.image
        });
      }
    });

    // Filter out recommendations that are already in the cart
    mappedSuggestions = mappedSuggestions.filter(sug => {
      return !cartItems.some(item => {
        const itemTitle = (item.product_title || item.title || '').toLowerCase();
        const sugTitle = sug.title.toLowerCase();
        return Number(item.variant_id) === Number(sug.id) || 
               Number(item.id) === Number(sug.id) ||
               itemTitle.includes(sugTitle) ||
               sugTitle.includes(itemTitle);
      });
    });

    if (mappedSuggestions.length === 0) {
      container.innerHTML = '';
      return;
    }

    let listHtml = '';
    mappedSuggestions.slice(0, 3).forEach(sug => {
      let formattedPrice = '';
      if (typeof sug.price === 'number' || !isNaN(Number(sug.price))) {
        formattedPrice = '₹' + parseFloat(sug.price).toLocaleString('en-IN');
      } else {
        formattedPrice = sug.price;
      }

      listHtml += `
        <div class="cart-drawer-upsell-row">
          <div class="cart-drawer-upsell-img">
            <img src="${sug.image}" alt="${sug.title}">
          </div>
          <div class="cart-drawer-upsell-info">
            <div style="font-size: 0.8rem; font-weight: 700; color: var(--color-primary); line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">${sug.title}</div>
            <div style="font-size: 0.76rem; font-weight: 800; color: var(--color-secondary); margin-top: 2px;">${formattedPrice}</div>
          </div>
          <button type="button" class="btn-add-upsell" onclick="window.addAddonToCart(${sug.id})">
            + Add
          </button>
        </div>
      `;
    });

    container.innerHTML = `
      <div class="cart-drawer__upsells" style="margin-top: 24px; padding: 0 4px;">
        <h3 class="cart-drawer__upsells-title" style="font-size: 0.74rem; font-weight: 800; text-transform: uppercase; color: rgba(46,46,46,0.5); letter-spacing: 0.08em; margin-bottom: 12px;">Complete Your Setup</h3>
        <div class="cart-drawer__upsell-list" style="display: flex; flex-direction: column; gap: 8px;">
          ${listHtml}
        </div>
      </div>
    `;
  });
}

function updateCartQuantity(key, quantity) {
  fetch(window.routes.cart_change_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    refreshCartDrawer();
  })
  .catch(error => {
    console.error('Error updating cart item quantity:', error);
  });
}

// Expose updateCartQuantity globally for inline onClick events
window.updateCartQuantity = updateCartQuantity;

// Helper to format Shopify money values (graceful fallback)
function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents);
  }
  const dollars = (cents / 100).toFixed(2);
  const parts = dollars.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return '₹' + parts.join('.');
}

/* --- Advanced Mattress Quiz Logic --- */
function initQuiz() {
  const container = document.querySelector('.quiz-container');
  if (!container) return;

  const steps = container.querySelectorAll('.quiz-step');
  const optionCards = container.querySelectorAll('.quiz-option-card');
  const progressFill = container.querySelector('.quiz-progress-fill');
  const nextBtn = container.getElementById('QuizNextBtn');
  const prevBtn = container.getElementById('QuizPrevBtn');
  const resultDiv = container.querySelector('.quiz-result');
  const quizWorkflowDiv = container.querySelector('.quiz-workflow');

  let currentStepIndex = 0;
  let userAnswers = {}; // Store quiz choices

  // Update progress bar
  function updateProgress() {
    const percent = ((currentStepIndex) / (steps.length)) * 100;
    if (progressFill) progressFill.style.width = percent + '%';
  }

  // Show/Hide steps
  function showStep(index) {
    steps.forEach((step, idx) => {
      step.classList.toggle('active', idx === index);
    });

    if (prevBtn) {
      prevBtn.style.display = index === 0 ? 'none' : 'inline-block';
    }

    if (nextBtn) {
      nextBtn.textContent = index === steps.length - 1 ? 'Get Recommendation' : 'Next';
      // Disable next button if no option selected in current step
      const currentStep = steps[index];
      const hasSelection = currentStep.querySelector('.quiz-option-card.selected');
      nextBtn.disabled = !hasSelection;
    }

    updateProgress();
  }

  // Handle Card Option Clicks
  optionCards.forEach(card => {
    card.addEventListener('click', function() {
      const step = this.closest('.quiz-step');
      const stepIndex = parseInt(step.dataset.stepIndex);
      const questionId = step.dataset.questionId;
      const val = this.dataset.value;

      // Unselect others in same step
      step.querySelectorAll('.quiz-option-card').forEach(c => c.classList.remove('selected'));
      this.classList.add('selected');

      userAnswers[questionId] = val;

      // Enable Next Button
      if (nextBtn) nextBtn.disabled = false;
    });
  });

  // Next Button Click
  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      if (currentStepIndex < steps.length - 1) {
        currentStepIndex++;
        showStep(currentStepIndex);
      } else {
        // Evaluate quiz and show recommendation
        evaluateQuizResults(userAnswers);
      }
    });
  }

  // Prev Button Click
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      if (currentStepIndex > 0) {
        currentStepIndex--;
        showStep(currentStepIndex);
      }
    });
  }

  // Evaluate Results
  function evaluateQuizResults(answers) {
    let recProduct = {
      title: "CozyCub Orthopedic Memory Foam Mattress",
      url: "/products/orthopedic-memory-foam-mattress",
      price: "₹9,999",
      img: "https://images.unsplash.com/photo-1616046229478-9901c5536a45?q=80&w=800&auto=format&fit=crop",
      desc: "Our best-selling orthopedic mattress designed for pressure relief, posture support, and body alignment."
    };

    // Simple routing logic based on user preferences
    if (answers['firmness'] === 'soft' || answers['sleep_style'] === 'side') {
      recProduct = {
        title: "CozyCub Original Gel Memory Foam Mattress",
        url: "/products/cozycub-original-mattress",
        price: "₹12,499",
        img: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=800&auto=format&fit=crop",
        desc: "Features plush CoolTEC cooling gel memory foam, contouring comfort, and zero motion transfer."
      };
    } else if (answers['special'] === 'latex' || answers['weight'] === 'heavy') {
      recProduct = {
        title: "CozyCub Hybrid Natural Latex Mattress",
        url: "/products/cozycub-hybrid-latex-mattress",
        price: "₹18,999",
        img: "https://images.unsplash.com/photo-1540518614846-7eded433c457?q=80&w=800&auto=format&fit=crop",
        desc: "Combines 100% natural organic latex bounce with individually wrapped pocket spring support."
      };
    }

    // Render output
    const recTitle = document.getElementById('QuizRecTitle');
    const recDesc = document.getElementById('QuizRecDesc');
    const recPrice = document.getElementById('QuizRecPrice');
    const recLink = document.getElementById('QuizRecLink');
    const recImg = document.getElementById('QuizRecImg');

    if (recTitle) recTitle.textContent = recProduct.title;
    if (recDesc) recDesc.textContent = recProduct.desc;
    if (recPrice) recPrice.textContent = recProduct.price;
    if (recLink) recLink.href = recProduct.url;
    if (recImg) recImg.src = recProduct.img;

    // Show result view
    if (quizWorkflowDiv) quizWorkflowDiv.style.display = 'none';
    if (resultDiv) resultDiv.classList.add('active');
    if (progressFill) progressFill.style.width = '100%';
  }

  // Reset quiz
  window.resetQuiz = function() {
    currentStepIndex = 0;
    userAnswers = {};
    optionCards.forEach(c => c.classList.remove('selected'));
    if (quizWorkflowDiv) quizWorkflowDiv.style.display = 'flex';
    if (resultDiv) resultDiv.classList.remove('active');
    showStep(0);
  };

  // Start Quiz
  showStep(0);
}

/* --- Reviews Carousel Navigation --- */
function initReviewsCarousel() {
  const carousel = document.querySelector('.reviews-carousel');
  if (!carousel) return;

  const slider = carousel.querySelector('.reviews-slider');
  const prevBtn = carousel.querySelector('.carousel-arrow--prev');
  const nextBtn = carousel.querySelector('.carousel-arrow--next');

  if (!slider || !prevBtn || !nextBtn) return;

  let index = 0;

  function getCardWidth() {
    const card = slider.querySelector('.review-card');
    return card ? card.offsetWidth + 24 : 0; // card width + gap
  }

  function getVisibleCards() {
    if (window.innerWidth >= 992) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  }

  function slide() {
    const width = getCardWidth();
    slider.style.transform = `translateX(-${index * width}px)`;
  }

  nextBtn.addEventListener('click', function() {
    const totalCards = slider.querySelectorAll('.review-card').length;
    const visibleCards = getVisibleCards();
    if (index < totalCards - visibleCards) {
      index++;
    } else {
      index = 0; // loop back
    }
    slide();
  });

  prevBtn.addEventListener('click', function() {
    const totalCards = slider.querySelectorAll('.review-card').length;
    const visibleCards = getVisibleCards();
    if (index > 0) {
      index--;
    } else {
      index = totalCards - visibleCards; // jump to end
    }
    slide();
  });

  // Handle window resizing
  window.addEventListener('resize', slide);
}

/* --- FAQ Accordion Grid --- */
function initFaqAccordion() {
  const items = document.querySelectorAll('.faq-accordion-item');

  items.forEach(item => {
    const header = item.querySelector('.faq-accordion-header');
    header.addEventListener('click', function() {
      const isOpen = item.classList.contains('open');
      
      // Close all other FAQs
      items.forEach(i => {
        i.classList.remove('open');
        i.querySelector('.faq-accordion-content').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('open');
        const content = item.querySelector('.faq-accordion-content');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/* --- Newsletter Coupon Reveal Modal --- */
function initNewsletterCoupon() {
  const forms = document.querySelectorAll('form[id*="Newsletter"], form[id*="newsletter"], form[id*="contact"]');
  const modal = document.getElementById('DiscountModal');
  const closeBtn = document.querySelector('.discount-modal-close');
  const copyBtn = document.querySelector('.coupon-copy-btn');
  const couponText = document.getElementById('CouponCodeText');

  if (!modal) return;

  // Slide in coupon if url contains successful posting params
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('customer_posted') === 'true' || window.location.search.indexOf('contact%5Btags%5D=newsletter') > -1) {
    setTimeout(() => {
      modal.classList.add('open');
    }, 500);
  }

  forms.forEach(form => {
    // Check if the form is a newsletter submission
    const tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (tagsInput && tagsInput.value === 'newsletter') {
      form.addEventListener('submit', function(e) {
        // Give Shopify standard form handler a brief moment to process then slide in coupon modal
        setTimeout(() => {
          modal.classList.add('open');
        }, 800);
      });
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      modal.classList.remove('open');
    });
  }

  if (copyBtn && couponText) {
    copyBtn.addEventListener('click', function() {
      navigator.clipboard.writeText(couponText.textContent.trim())
      .then(() => {
        copyBtn.textContent = 'Copied!';
        copyBtn.style.backgroundColor = 'var(--color-accent)';
        setTimeout(() => {
          copyBtn.textContent = 'Copy';
          copyBtn.style.backgroundColor = 'var(--color-primary)';
        }, 2000);
      })
      .catch(err => {
        console.error('Could not copy coupon text: ', err);
      });
    });
  }
}

/* --- Search Modal Overlay Controls --- */
function initSearchModal() {
  const trigger = document.querySelector('.header__icon--search-trigger');
  const modal = document.getElementById('SearchModal');
  const closeBtn = document.getElementById('CloseSearchModal');
  const input = document.getElementById('SearchModalInput');

  if (!trigger || !modal || !closeBtn) return;

  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    modal.classList.add('open');
    if (input) {
      setTimeout(() => input.focus(), 150);
    }
  });

  closeBtn.addEventListener('click', function() {
    modal.classList.remove('open');
  });

  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      modal.classList.remove('open');
    }
  });

  // Close modal on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) {
      modal.classList.remove('open');
    }
  });
}

/* --- Mega Menu Tab & Subfilter Switching --- */
function initMegaMenu() {
  const tabBtns = document.querySelectorAll('.mega-menu__tab-btn');
  const subfilterBtns = document.querySelectorAll('.mega-menu__subfilter-btn');

  // Category Tab switching
  tabBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const targetTabId = this.dataset.megaTab;

      const parentMenu = this.closest('.mega-menu');
      parentMenu.querySelectorAll('.mega-menu__tab-btn').forEach(b => b.classList.remove('active'));
      parentMenu.querySelectorAll('.mega-menu__tab-content').forEach(c => c.classList.remove('active'));

      this.classList.add('active');
      const targetContent = parentMenu.querySelector(`#${targetTabId}`);
      if (targetContent) {
        targetContent.classList.add('active');
      }

      // Reset sub-filter button to "All" inside the mega menu
      parentMenu.querySelectorAll('.mega-menu__subfilter-btn').forEach(b => {
        b.classList.toggle('active', b.dataset.subfilter === 'all');
      });

      // Show all products in active tab
      if (targetContent) {
        targetContent.querySelectorAll('.mega-menu__product-card').forEach(card => {
          card.style.display = 'flex';
        });
      }
    });
  });

  // Sub-filter switching
  subfilterBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const subfilterVal = this.dataset.subfilter;

      const parentMenu = this.closest('.mega-menu');
      parentMenu.querySelectorAll('.mega-menu__subfilter-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const activeContent = parentMenu.querySelector('.mega-menu__tab-content.active');
      if (!activeContent) return;

      const cards = activeContent.querySelectorAll('.mega-menu__product-card');
      cards.forEach(card => {
        const cardCat = card.dataset.cat;
        if (subfilterVal === 'all' || cardCat === subfilterVal) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
}

/* --- Hero Swiper Slider Init --- */
function initHeroSlider() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initHeroSlider, 100);
    return;
  }

  // 1. Desktop & Universal Responsive Hero Sliders
  const heroContainers = document.querySelectorAll('.hero-swiper');
  heroContainers.forEach(container => {
    if (container.swiper) return; // Prevent duplicate initialization

    const sectionEl = container.closest('.hero-slider-section');
    const delay = sectionEl ? parseInt(sectionEl.dataset.autoplayDelay) || 5000 : 5000;
    const enableAutoplay = sectionEl ? sectionEl.dataset.autoplay !== 'false' : true;

    // Set CSS bullet-duration variable to sync CSS progress animation
    container.style.setProperty('--bullet-duration', (delay / 1000) + 's');

    new Swiper(container, {
      loop: true,
      speed: 700,
      autoplay: enableAutoplay ? {
        delay: delay,
        disableOnInteraction: false
      } : false,
      pagination: {
        el: container.querySelector('.hero-swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: container.querySelector('.hero-swiper-button-next'),
        prevEl: container.querySelector('.hero-swiper-button-prev')
      }
    });
  });

  // 2. Mobile-Dedicated Hero Sliders
  const mobileHeroContainers = document.querySelectorAll('.hero-mobile-swiper');
  mobileHeroContainers.forEach(container => {
    if (container.swiper) return;

    const sectionEl = container.closest('.hero-mobile-only-section');
    const delay = sectionEl ? parseInt(sectionEl.dataset.autoplayDelay) || 5000 : 5000;
    const enableAutoplay = sectionEl ? sectionEl.dataset.autoplay !== 'false' : true;

    container.style.setProperty('--bullet-duration', (delay / 1000) + 's');

    new Swiper(container, {
      loop: true,
      speed: 600,
      autoplay: enableAutoplay ? {
        delay: delay,
        disableOnInteraction: false
      } : false,
      pagination: {
        el: container.querySelector('.hero-mobile-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: container.querySelector('.hero-mobile-button-next'),
        prevEl: container.querySelector('.hero-mobile-button-prev')
      }
    });
  });
}

/* --- Featured Products Swiper Init --- */
function initFeaturedProductsSlider() {
  const container = document.querySelector('.explore-featured-swiper');
  if (!container) return;

  if (typeof Swiper === 'undefined') {
    // Retry in 100ms if Swiper library hasn't finished loading from CDN
    setTimeout(initFeaturedProductsSlider, 100);
    return;
  }

  const featuredSwiper = new Swiper('.explore-featured-swiper', {
    loop: true,
    spaceBetween: 30,
    slidesPerView: 1.2, // Show 1.2 slides on mobile so users know to swipe
    pagination: {
      el: '.explore-featured-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.explore-featured-next',
      prevEl: '.explore-featured-prev'
    },
    breakpoints: {
      // Desktop breakpoint
      768: {
        slidesPerView: 2 // Show 2 slides side-by-side on desktop matching mockup
      }
    }
  });
}

/* --- In Action Reels Slider Swiper Init --- */
function initInActionSlider() {
  const container = document.querySelector('.in-action-swiper');
  if (!container) return;

  if (typeof Swiper === 'undefined') {
    // Retry in 100ms if Swiper library hasn't finished loading from CDN
    setTimeout(initInActionSlider, 100);
    return;
  }

  const inActionSwiper = new Swiper('.in-action-swiper', {
    loop: false,
    initialSlide: 3, // Start with the 4th card active
    centeredSlides: true,
    slideToClickedSlide: true,
    spaceBetween: 12,
    slidesPerView: 'auto', // Allow slides to set their own width (210px in CSS)
    navigation: {
      nextEl: '.in-action-next',
      prevEl: '.in-action-prev'
    }
  });

  // Attach AJAX Cart listeners to tag-add-buttons in this section
  const addBtns = container.querySelectorAll('.in-action-ajax-add');
  addBtns.forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      let variantId = this.dataset.variantId || this.getAttribute('data-variant-id');
      const originalText = this.textContent;

      this.textContent = '...';
      this.disabled = true;

      // Dynamic Fallback: If variantId is missing or "null", fetch first available store product variant
      if (!variantId || variantId === 'null' || variantId === 'undefined') {
        try {
          const res = await fetch('/products.json?limit=5');
          const data = await res.json();
          if (data && data.products && data.products.length > 0) {
            for (const p of data.products) {
              const avail = p.variants ? p.variants.find(v => v.available) : null;
              if (avail) {
                variantId = avail.id;
                this.dataset.variantId = variantId;
                this.setAttribute('data-variant-id', variantId);
                break;
              }
            }
            if (!variantId && data.products[0].variants && data.products[0].variants.length > 0) {
              variantId = data.products[0].variants[0].id;
              this.dataset.variantId = variantId;
              this.setAttribute('data-variant-id', variantId);
            }
          }
        } catch(err) {
          console.error('Error fetching fallback product variant:', err);
        }
      }

      if (!variantId || variantId === 'null' || variantId === 'undefined') {
        window.location.href = '/collections/all';
        this.textContent = originalText;
        this.disabled = false;
        return;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json' 
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.description || 'Failed to add item to cart');
        }

        this.textContent = '✓';
        
        // Open Cart Drawer & Refresh Cart
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else if (typeof window.updateCartDrawer === 'function') {
          window.updateCartDrawer();
        } else if (window.CozyCart && typeof window.CozyCart.open === 'function') {
          window.CozyCart.updateCartCount();
          window.CozyCart.renderCartDrawer();
          window.CozyCart.open();
        } else {
          window.location.href = '/cart';
        }

        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('Add to cart error:', err);
        this.textContent = originalText;
        this.disabled = false;
      }
    });
  });
}

/* --- Shopify Customizer Theme Editor Event Listeners --- */
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.hero-swiper') || event.target.querySelector('.hero-mobile-swiper')) {
    initHeroSlider();
  }
  if (event.target.querySelector('.explore-featured-swiper')) {
    initFeaturedProductsSlider();
  }
  if (event.target.querySelector('.in-action-swiper')) {
    initInActionSlider();
  }
  if (event.target.querySelector('.reviews-carousel')) {
    initReviewsCarousel();
  }
  if (event.target.querySelector('.quiz-container')) {
    initQuiz();
  }
  if (event.target.querySelector('.faq-grid')) {
    initFaqAccordion();
  }
});


